import React, { Component } from "react";
import { Modal, Select } from "antd";

const { Option } = Select;
const reasons = ["On Hold", "Competitor", "No Contact", "Not Interested"]

class ProposalClose extends Component {
  state = {
    selectedReason: reasons[0],
    info: ''
  }

  handleChange = (e, type) => {
    this.setState({[type]: e})
  }

  handleTextChange = (e, type) => {
    this.setState({[type]: e.target.value})
  }

  onCloseProposal = () => {
    const { patchCommercialProposal, commercialProposalDetail, onCancel, onChangeView, getProposalList } = this.props
    const { selectedReason, info } = this.state;
    patchCommercialProposal(commercialProposalDetail?.uuid, {
      proposal_status: 'closed',
      close_reason: selectedReason,
      close_additional_info: info
    })

    setTimeout(() => {onCancel(); onChangeView(0); getProposalList()}, 1000)
  }

  render() {
    const { visible, onCancel } = this.props;
    const { selectedReason, info } = this.state;

    return (
      <Modal
        title="Close Proposal"
        visible={visible}
        closable={false}
        footer={[
          <button key="cancel" className="btn btn-bdr" onClick={() => onCancel()}>Cancel</button>,
          <button key="save" className="btn btn-warning" onClick={this.onCloseProposal}>Close Proposal</button>
        ]}
      >
        <p>
          This proposal will be archived under the company name. It will still be viewable, and can be reinstated in future.
        </p>
        <p>
          Please provide a reason as to why you are closing this proposal.
        </p>
        <div className="form-group">
          <div className="fitem">
            <b className="d-block mb-10">Reason</b>
            <Select
              defaultValue={selectedReason}
              value={selectedReason}
              showArrow
              showSearch
              virtual={false}
              style={{ width: '100%' }}
              onChange={(e) => this.handleChange(e, 'selectedReason')}
            >
              {reasons.map(reason => (
                <Option key={reason} value={reason}>{reason}</Option>
              ))}
            </Select>
          </div>
          <div className="fitem">
            <b className="d-block mb-10">Additional Information</b>
            <textarea
              id="addInfo"
              rows="3"
              name="addInfoText"
              type="text"
              className="form-control"
              placeholder="Additional information regarding the closure of this proposal"
              value={info}
              onChange={(e) => this.handleTextChange(e, 'info')} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default ProposalClose;
